export const REQUEST = "/api/storehouse/category-scafolding/-REQUEST";
export const SUCCESS = "/api/storehouse/category-scafolding/-SUCCESS";
export const FAILURE = "/api/storehouse/category-scafolding/-FAILURE";


// WEBPACK FOOTER //
// ./src/ducks/categoriesScaffolding/constants.js